<nz-spin [nzSpinning]="loading">
  <nz-tabs>
    <nz-tab nzTitle="Übersicht">
      <nz-row>
        <form nz-form [formGroup]="form" style="width: 100%" (ngSubmit)="submitForm()">
          <nz-form-item>
            <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="name" nzRequired>
              <span>Name</span>
            </nz-form-label>
            <nz-form-control [nzSm]="14" [nzXs]="24" nzErrorTip="Bitte geben Sie den Variantennamen ein!">
              <nz-select
                nzShowSearch
                nzAllowClear
                [nzDropdownRender]="renderTemplate"
                nzPlaceHolder=""
                id="articleVariantConfigurationId"
                formControlName="articleVariantConfigurationId"
                (ngModelChange)="nameChanged()"
                (nzOnSearch)="nameSearch($event)"
                >
                @for (item of articleVariantConfigurations; track item) {
                  <nz-option [nzLabel]="item.value" [nzValue]="item.id"></nz-option>
                }
              </nz-select>
              <ng-template #renderTemplate>
                <nz-divider></nz-divider>
                <div class="container">
                  <input type="text" nz-input #inputElement />
                  <a class="add-item" (click)="addVariantName(inputElement.value)"><i nz-icon nzType="plus"></i> hinzufügen</a>
                </div>
              </ng-template>
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="orderNumber" nzRequired>
              <span>Bestellnummer</span>
            </nz-form-label>
            <nz-form-control [nzSm]="14" [nzXs]="24" nzErrorTip="Bitte Bestellnummer eingeben!">
              <input nz-input id="orderNumber" formControlName="orderNumber">
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="ean">
              <span>EAN</span>
            </nz-form-label>
            <nz-form-control [nzSm]="14" [nzXs]="24" nzErrorTip="Bitte geben Sie EAN ein!">
              <input nz-input id="ean" formControlName="ean" type="number" />
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="stockMin">
              <span>Lager min</span>
            </nz-form-label>
            <nz-form-control [nzSm]="14" [nzXs]="24">
              <input nz-input id="stockMin" formControlName="stockMin" type="number" />
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="purchaseUnit">
              <span>Inhalt</span>
            </nz-form-label>
            <nz-form-control [nzSm]="14" [nzXs]="24">
              @if (units[editObject?.unitId]) {
                <nz-input-group [nzAddOnAfter]="units[editObject.unitId]">
                  <input nz-input id="purchaseUnit" formControlName="purchaseUnit" type="number" />
                </nz-input-group>
              } @else {
                <input nz-input id="purchaseUnit" formControlName="purchaseUnit" type="number" />
              }
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="packUnit">
              <span>Verpackungseinheit</span>
            </nz-form-label>
            <nz-form-control [nzSm]="14" [nzXs]="24">
              <input nz-input id="packUnit" formControlName="packUnit" type="text" />
            </nz-form-control>
          </nz-form-item>

          <nz-row nzJustify="center">
            <nz-col [nzSm]="6" [nzXs]="12">
              <nz-form-item>
                <nz-form-label nzFor="isGiftbox">
                  <span>Geschenkset</span>
                </nz-form-label>
                <nz-form-control>
                  <label
                    class="verify-checkbox"
                  nz-checkbox formControlName="isGiftbox" nzDisabled>Ja/Nein</label>
                </nz-form-control>
              </nz-form-item>
            </nz-col>
            <nz-col [nzSm]="6" [nzXs]="12">

            </nz-col>
          </nz-row>
          @if (form.controls['isGiftbox'].value) {
            <nz-form-item class="formula">
              <nz-form-label [nzXs]="24" style="text-align: left">
                <span>Geschenkset-Formel</span>
              </nz-form-label>
              <nz-form-control [nzXs]="24" [nzSm]="12">
                <ul nz-list [nzDataSource]="selectedGiftboxArticles" nzBordered nzSize="large" class="form-control form-control--selected-articles">
                  <nz-list-header>ausgewählte Artikel</nz-list-header>
                  @for (item of selectedGiftboxArticles; track item; let i = $index) {
                    <li nz-list-item nzNoFlex class="article-item">
                      <ul nz-list-item-actions>
                        <nz-list-item-action>
                          <i
                            nz-icon
                            nzType="close"
                            nzTheme="outline"
                            (click)="removeGiftboxFromList(i)"
                            nz-tooltip
                            nzTooltipTitle="Geschenkset aus Liste entfernen"
                          ></i>
                        </nz-list-item-action>
                      </ul>
                      {{ item.fullName }}
                    </li>
                  }
                </ul>
              </nz-form-control>
              <nz-form-control [nzXs]="24" [nzSm]="12">
                @if (giftboxFormulaArticles$ | async; as articles) {
                  <ul nz-list [nzDataSource]="articles" nzBordered nzSize="large">
                    <nz-list-header>alle Artikel <app-table-search-bar (search)="searchGiftboxArticles($event)" [searchValue]="gitboxSearch"></app-table-search-bar></nz-list-header>
                    @for (item of articles; track item) {
                      <li nz-list-item nzNoFlex class="article-item">
                        <ul nz-list-item-actions>
                          <nz-list-item-action>
                            <i
                              nz-icon
                              nzType="arrow-left"
                              nzTheme="outline"
                              (click)="addGiftboxToList(item)"
                              nz-tooltip
                              nzTooltipTitle="Geschenkset zur Liste hinzufügen"
                            ></i>
                          </nz-list-item-action>
                        </ul>
                        {{ item.fullName }}
                      </li>
                    }
                  </ul>
                }
              </nz-form-control>
            </nz-form-item>
          }
        </form>
      </nz-row>
    </nz-tab>
    @if (false) {
      <nz-tab nzTitle="Großgebinde / Produktion">
        <nz-row>
          <form nz-form [formGroup]="form" style="width: 100%">
            <nz-form-item>
              <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="weight">
                <span>Gewicht</span>
              </nz-form-label>
              <nz-form-control [nzSm]="14" [nzXs]="24">
                <input nz-input id="weight" formControlName="weight" type="number" />
              </nz-form-control>
            </nz-form-item>
            <nz-form-item>
              <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="purchaseUnitHidden">
                <span>Inhalt</span>
              </nz-form-label>
              <nz-form-control [nzSm]="14" [nzXs]="24">
                @if (units[editObject?.unitId]) {
                  <nz-input-group [nzAddOnAfter]="units[editObject.unitId]">
                    <input nz-input id="purchaseUnitHidden" formControlName="purchaseUnit" type="number" />
                  </nz-input-group>
                } @else {
                  <input nz-input id="purchaseUnitHidden" formControlName="purchaseUnit" type="number" />
                }
              </nz-form-control>
            </nz-form-item>
            <nz-form-item>
              <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="packUnitHidden">
                <span>Verpackungseinheit</span>
              </nz-form-label>
              <nz-form-control [nzSm]="14" [nzXs]="24">
                <input nz-input id="packUnitHidden" formControlName="packUnit" type="text" />
              </nz-form-control>
            </nz-form-item>
          </form>
        </nz-row>
      </nz-tab>
    }
  </nz-tabs>
</nz-spin>
